/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Stats_Sandboxestooltip1Inputs */

const id_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox adalah grup penawaran`)
};

const ms_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox ialah kumpulan tawaran`)
};

const da_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En sandbox er gruppen af tilbud`)
};

const de_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Sandbox ist die Gruppe von Angeboten`)
};

const en_us2_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sandbox is the group of offers`)
};

const es_es2_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un Sandbox es el grupo de ofertas`)
};

const es_mx2_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un Sandbox es el grupo de ofertas`)
};

const fil_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang sandbox ay ang grupo ng mga offer`)
};

const fr_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un sandbox est le groupe d'offres`)
};

const it_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un sandbox è il gruppo di offerte`)
};

const hu_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A sandbox az ajánlatok csoportja`)
};

const nl_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een sandbox is de groep aanbiedingen`)
};

const no_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En sandbox er gruppen av tilbud`)
};

const pl_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox to grupa ofert`)
};

const pt_br2_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxes tooltip`)
};

const pt_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma sandbox é o grupo de ofertas`)
};

const ro_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un sandbox este grupul de oferte`)
};

const fi_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiekkalaatikko on tarjousten ryhmä`)
};

const sv_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En sandlåda är gruppen av erbjudanden`)
};

const vi_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Một Sandbox là nhóm các ưu đãi`)
};

const tr_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox, teklifler grubudur`)
};

const cs_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox je skupina nabídek`)
};

const bg_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox е групата от оферти`)
};

const ru_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Песочница — это группа предложений`)
};

const uk_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox — це група пропозицій`)
};

const ar_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox هو مجموعة العروض`)
};

const hi_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सैंडबॉक्स ऑफ़र का समूह है`)
};

const th_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แซนด์บ็อกซ์คือกลุ่มของข้อเสนอ`)
};

const ja_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンドボックスはオファーのグループです`)
};

const zh_cn2_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxes tooltip`)
};

const zh_hant1_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxes tooltip`)
};

const ko_components_stats_sandboxestooltip1 = /** @type {(inputs: Components_Stats_Sandboxestooltip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandboxes tooltip`)
};

/**
* | output |
* | --- |
* | "A sandbox is the group of offers" |
*
* @param {Components_Stats_Sandboxestooltip1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_stats_sandboxestooltip1 = /** @type {((inputs?: Components_Stats_Sandboxestooltip1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Stats_Sandboxestooltip1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_stats_sandboxestooltip1(inputs)
	if (locale === "ms") return ms_components_stats_sandboxestooltip1(inputs)
	if (locale === "da") return da_components_stats_sandboxestooltip1(inputs)
	if (locale === "de") return de_components_stats_sandboxestooltip1(inputs)
	if (locale === "en-US") return en_us2_components_stats_sandboxestooltip1(inputs)
	if (locale === "es-ES") return es_es2_components_stats_sandboxestooltip1(inputs)
	if (locale === "es-MX") return es_mx2_components_stats_sandboxestooltip1(inputs)
	if (locale === "fil") return fil_components_stats_sandboxestooltip1(inputs)
	if (locale === "fr") return fr_components_stats_sandboxestooltip1(inputs)
	if (locale === "it") return it_components_stats_sandboxestooltip1(inputs)
	if (locale === "hu") return hu_components_stats_sandboxestooltip1(inputs)
	if (locale === "nl") return nl_components_stats_sandboxestooltip1(inputs)
	if (locale === "no") return no_components_stats_sandboxestooltip1(inputs)
	if (locale === "pl") return pl_components_stats_sandboxestooltip1(inputs)
	if (locale === "pt-BR") return pt_br2_components_stats_sandboxestooltip1(inputs)
	if (locale === "pt") return pt_components_stats_sandboxestooltip1(inputs)
	if (locale === "ro") return ro_components_stats_sandboxestooltip1(inputs)
	if (locale === "fi") return fi_components_stats_sandboxestooltip1(inputs)
	if (locale === "sv") return sv_components_stats_sandboxestooltip1(inputs)
	if (locale === "vi") return vi_components_stats_sandboxestooltip1(inputs)
	if (locale === "tr") return tr_components_stats_sandboxestooltip1(inputs)
	if (locale === "cs") return cs_components_stats_sandboxestooltip1(inputs)
	if (locale === "bg") return bg_components_stats_sandboxestooltip1(inputs)
	if (locale === "ru") return ru_components_stats_sandboxestooltip1(inputs)
	if (locale === "uk") return uk_components_stats_sandboxestooltip1(inputs)
	if (locale === "ar") return ar_components_stats_sandboxestooltip1(inputs)
	if (locale === "hi") return hi_components_stats_sandboxestooltip1(inputs)
	if (locale === "th") return th_components_stats_sandboxestooltip1(inputs)
	if (locale === "ja") return ja_components_stats_sandboxestooltip1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_stats_sandboxestooltip1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_stats_sandboxestooltip1(inputs)
	return ko_components_stats_sandboxestooltip1(inputs)
});
export { components_stats_sandboxestooltip1 as "components.stats.sandboxesTooltip" }